export default {
    state: {
        data: null,
        gametype: "",
        score: 0,
        currentQuestion: 0,
        questionCount: 0,
        //completed: false,
        //explained: false,
        feedbackData: {},
        state: "intro" // intro, explanation, round, feedback
    },
    mutations: {
        initiateRound(state) {
            state.state = "intro";
            state.currentQuestion = 0;
        },

        setRoundState(state, roundState) {
            state.state = roundState;
        },

        setCurrentQuestion(state, int) {
            state.currentQuestion = int;
        },

        setRoundData(state, data) {
            state.data = data;
            state.questionCount =
                state.data == null || state.data.questions == null
                    ? 0
                    : state.data.questions.questions.length;
            state.gametype =
                data == null || data.gametype == null ? "" : data.gametype;
            state.score = 0;
        },

        incrementScore(state) {
            state.score++;
        },

        setRoundScore(state, score) {
            state.score = score;
        },

        setFeedbackData(state, data) {
            state.feedbackData = data;
        }
    },
    actions: {
        addRoundScore(store) {
            return new Promise((resolve, reject) => {
                store.commit("incrementScore");
                resolve();
            });
        },

        setRoundScore(store, score) {
            return new Promise((resolve, reject) => {
                store.commit("setRoundScore", score);
                resolve();
            });
        },

        setRoundData(store, data) {
            return new Promise((resolve, reject) => {
                store.commit("initiateRound");
                store.commit("setRoundData", data);
                if (data != null) {


                console.log('setRoundData: hide_intro:');
                console.log(data.questions.hide_intro);

                    if (data.questions.hide_intro == "Yes") {
                        if (
                            data.questions.hide_explanation == "Yes" ||
                            data.questions.hide_explanation == "Popup"
                        ) {
                            store.commit("setRoundState", "round");
                        } else {
                            store.commit("setRoundState", "explanation");
                        }
                    }
                }
                resolve();
            });
        },

        setRoundState(store, state) {
            return new Promise((resolve, reject) => {
                store.commit("setRoundState", state);
                resolve();
            });
        },

        toNextQuestion(store) {
            return new Promise((resolve, reject) => {
                store.commit(
                    "setCurrentQuestion",
                    store.state.currentQuestion + 1
                );
                resolve();
            });
        },

        toPreviousQuestion(store) {
            return new Promise((resolve, reject) => {
                store.commit(
                    "setCurrentQuestion",
                    store.state.currentQuestion - 1
                );
                resolve();
            });
        },

        completeRound(store, data) {
            return new Promise((resolve, reject) => {
                if (
                    store.state.data != null &&
                    store.state.data.hide_feedback == "Yes"
                ) {
                    let lastRound = store.getters.lastRound;
                    if (lastRound) store.dispatch("toNextStage");
                    else store.dispatch("toNextRound");
                } else store.commit("setRoundState", "feedback");
                resolve();
            });
        },

        setFeedbackData(store, data) {
            return new Promise((resolve, reject) => {
                store.commit("setFeedbackData", data);
                resolve();
            });
        }
    },
    getters: {
        roundScore(state) {
            return state.score;
        },
        roundState(state) {
            return state.state;
        },
        questionData(state) {
            if (
                state.data == undefined ||
                state.data.questions == undefined ||
                state.data.questions.questions.length == 0
            )
                return null;


            // console.log('ROUND JS questionData');

            // console.log(state.data.questions.questions[state.currentQuestion]);
            // console.log(state.currentQuestion+' of '+state.questionCount);

            return state.data.questions.questions[state.currentQuestion];
        },
        roundData(state) {
            return state.data;
        },
        currentQuestion(state) {
            return state.currentQuestion;
        },
        questionCount(state) {
            return state.questionCount;
        },
        lastQuestion(state) {
            return state.currentQuestion >= state.questionCount - 1;
        },
        roundType(state) {
            return state.gametype;
        },
        feedbackData(state) {
            return state.feedbackData;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/round.js